export const SERVICE_BASE = "https://modalityhealthcare.azure-api.net/emea";
export const AZURE_API_KEY = "4e51858057c24d76a9926e8638077c48";
export const APP_INSIGHTS_KEY = "882e4f33-f6f6-4506-b5c2-6637d7619b0b";
export const ONEC_API_OPTIONS = {
  headers: {'Ocp-Apim-Subscription-Key': AZURE_API_KEY}
};
// export const WEB_RTC_CONSTRAINTS = {
//   audio: true,
//   video: true
// };